// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
// antd v5 static APIs (Modal.confirm, message, notification) are broken on
// React 19 without this patch — they silently render nothing.
import '@ant-design/v5-patch-for-react-19';
import App from './App';
import AppInitializer from './components/AppInitializer';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext'; // Adjust if needed
import { CallSessionProvider } from './modules/callSync/context/CallSessionContext';
import { NotificationProvider } from './modules/notifications/NotificationContext';
import 'antd/dist/reset.css';


// ✅ For Material UI theme (optional if still using MUI)
import { ThemeProvider, CssBaseline } from '@mui/material';
import theme from './theme/theme'; // Your custom MUI theme

// ✅ If you're using Ant Design v5+
import { StyleProvider } from '@ant-design/cssinjs';

import reportWebVitals from './reportWebVitals';

// A data router (not <BrowserRouter>) so useBlocker works — an unsaved new
// case warns before any in-app navigation. Every route still lives in App's
// own <Routes>; this single splat route only hosts it.
// Inside the router: the notification store navigates to a notification's
// deep link, and inside AuthProvider because it connects the live stream with
// the signed-in user's token.
const router = createBrowserRouter([
  {
    path: '*',
    element: (
      <NotificationProvider>
        <App />
      </NotificationProvider>
    ),
  },
]);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <StyleProvider hashPriority="high"> {/* Ant Design v5 CSS-in-JS support */}
        <CssBaseline />
        <AppInitializer>
          <AuthProvider>
            {/* One call session for the whole app. A phone can only be on one
                call at a time, so the live call is a property of the user, not
                of whichever row started it — and it is rehydrated from the
                server on load so a browser reload never loses it. */}
            <CallSessionProvider>
              <RouterProvider router={router} />
            </CallSessionProvider>
          </AuthProvider>
        </AppInitializer>
    </StyleProvider>
  </React.StrictMode>
);

reportWebVitals();
